<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        Configuration
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        small
        @click="add()"
        v-if="checkPermission('app_encrypt_decrypt:add_configuration')"
        >Add Configuration</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-data-table
      :headers="headers"
      :items="config"
      :options.sync="options"
      :server-items-length="total"
      :loading="configLoader"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-form @submit.prevent="searchAll" type="submit">
          <v-row class="custom-row pl-5 pr-5">
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="key"
                outlined
                dense
                label="Key"
                class="pl-2"
              ></v-text-field>
            </v-col>
            <v-col cols="9" class="text-end pr-2 mb-2">
              <v-btn class="success" color="primary" @click="searchAll"
                >Search</v-btn
              >
              <v-btn
                color="white"
                class="ml-4"
                @click="(key = null), fetchList()"
                >Clear</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-2 mt-2"></v-divider>
      </template>
      <template v-slot:[`item.value`]="{ item }" class="d-flex">
        <button id="copyButton" class="d-flex">
          <v-icon class="mr-2" v-if="item.value" @click="copyText(item.value)"
            >mdi-content-copy</v-icon
          >

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                :id="'textToCopy-' + item.id"
                class="text-to-copy"
              >
                {{ wordWrap(item.value) }}
              </div>
            </template>
            <span>{{ item.value }}</span>
          </v-tooltip>
        </button>
      </template>
      <template v-slot:[`item.token_value`]="{ item }" class="d-flex">
        <button id="copyButton" class="d-flex">
          <v-icon
            class="mr-2"
            v-if="item.token_value"
            @click="copyText(item.token_value)"
            >mdi-content-copy</v-icon
          >

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                :id="'textToCopy-' + item.id"
                class="text-to-copy"
              >
                {{ wordWrap(item.token_value) }}
              </div>
            </template>
            <span>{{ item.token_value }}</span>
          </v-tooltip>
        </button>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">{{
          item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span
        ><span v-else>--</span>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at">{{
          item.updated_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span
        ><span v-else>--</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_encrypt_decrypt:update_configuration')"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit Configuration</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";

export default {
  components: {},

  data() {
    return {
      configLoader: false,
      options: {},
      config: [],
      headers: [
        {
          text: "Key",
          value: "key",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Value",
          value: "value",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Token Value",
          value: "token_value",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Created At",
          value: "created_at",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Created By",
          value: "created_by",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Updated By",
          value: "updated_by",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
      key: null,
      filtersArr: [],
      total: 0,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["snackBar", "configList"]),
    allFilters() {
      let obj = {
        key: this.key,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.configList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.config = res.data.records;

          this.total = res.data.total;
        })
        .catch(() => {
          this.configLoader = false;
        });
    },

    copyText(value) {
      const textarea = document.createElement("textarea");
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.snackBar({
        color: "success",
        message: "Text copied to clipboard!",
      });
    },
    add() {
      this.$router.push({
        name: "AddConfiguration",
        params: {
          id: 0,
        },
      });
    },
    wordWrap(text) {
      return text ? text.substring(0, 50) : "";
    },
    edit(item) {
      this.$router.push({
        name: "AddConfiguration",
        params: {
          id: item.id,
          key: item.key,
          value: item.value || "",
          token_value: item.token_value || "",
          encrypt_status: item.encrypt_status,
        },
      });
    },
    fetchList() {
      this.configLoader = true;
      this.configList({ ...this.options })
        .then((res) => {
          this.config = res.data.records;
          this.total = res.data.total;
          this.configLoader = false;
        })
        .catch(() => {
          this.configLoader = false;
        });
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  align-self: flex-end;
}
</style>
